"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var heading_text_1 = require("../../../primitives/heading-text");

exports.Heading = function (props) {
  var level = props.level || 1;
  level = level > 5 ? 1 : level;
  var headingStyles = [theme_pricing_system_1.pricingStyles.heading1TextStyle, theme_pricing_system_1.pricingStyles.heading2TextStyle, theme_pricing_system_1.pricingStyles.heading3TextStyle, theme_pricing_system_1.pricingStyles.heading4TextStyle, theme_pricing_system_1.pricingStyles.heading5TextStyle];
  return react_1.default.createElement(heading_text_1.HeadingText, {
    level: level,
    style: [headingStyles[level - 1], props.textStyle]
  }, props.children);
};